/**
 * A list-page href carrying the params the tile used to set on its own page.
 * Empty and null values are dropped, so `{ phase: null }` — the tile's "clear
 * the selection" click — opens the unfiltered list.
 */
export function listHref(
  path: string,
  params: Record<string, string | null | undefined>,
): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value) search.set(key, value);
  }
  const qs = search.toString();
  return qs ? `${path}?${qs}` : path;
}
